import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { isPreviewPlayerSelector } from '../../slices/chat/ChatSlice';
import {
  isEmbeddedPlayerSelector,
  isFullscreenSelector,
  isPublicUserSessionSelector,
} from '../../slices/vh-player/VHPlayerSlice';
import { Button } from '@virtidev/toolbox';
import { useTranslation } from 'react-i18next';
import { virtualHumanDataSelector } from '@vh/slices/VirtualHumanSlice';
import { useShouldShowFeedbackForms } from '@core/helpers/useShouldShowFeedbackForms';

const FinishSessionButton = ({ courseID }) => {
  const isPreviewPlayer = useSelector(isPreviewPlayerSelector);
  const isEmbeddedPlayer = useSelector(isEmbeddedPlayerSelector);
  const fullscreen = useSelector(isFullscreenSelector);
  const vh = useSelector(virtualHumanDataSelector);
  const { t } = useTranslation();
  let backToText = courseID ? t('backToCourse') : t('backToVirtualHumans');

  const isPublicUserSession = useSelector(isPublicUserSessionSelector);

  const [beforeVHForm, afterVHForm] = useShouldShowFeedbackForms(
    vh?.FeedbackFormBefore,
    vh?.FeedbackFormAfter,
    vh?.FeedbackFormBeforeCompleted,
    vh?.FeedbackFormAfterCompleted,
    isPreviewPlayer,
    isPublicUserSession
  );

  const [continueClicked, setContinueClicked] = useState(false);
  const showContinueToForm = afterVHForm && !continueClicked;

  if (showContinueToForm) {
    backToText = t('continueToForm');
  }

  if (
    isEmbeddedPlayer &&
    (continueClicked || (!continueClicked && !showContinueToForm))
  )
    return <></>;

  return (
    <Button
      onClick={() => {
        if (fullscreen) {
          document.exitFullscreen();
        }
        var event = new CustomEvent('onVHSessionCompleteAndUserContinued');
        window.parent.document.dispatchEvent(event);
        if (showContinueToForm) {
          setContinueClicked(true);
        }
      }}
      disabled={isPreviewPlayer}
      color="turquoise"
    >
      {backToText}
    </Button>
  );
};

export default FinishSessionButton;
